import _get from 'lodash/get';

export function setFormValues(_fields, _data) {
  Object.keys(_fields).forEach(fieldName => {
    const _field = _fields[fieldName];
    let value = _get(_data, fieldName);
    if (_field.type === 'select') {
      let _entity = _get(_data, fieldName);
      value = _entity.map(function(obj) {
        return { id: obj[_field.datasource.dataField] };
      });
    }

    if (value !== undefined && value !== null) {
      _field.value = value;
      if (Array.isArray(value)) {
        _field.initial = Array.from(value);
      } else {
        _field.initial = value;
      }
    }
  });

  return _fields;
}

export function addFieldToMessageDefinition(messageDefinition, dataid) {
  // Remove any numeric parts from the dataid (fieldnames are not numeric so these would be array indices)
  // Map indices can be provided in format field[1] which are converted to field.1 and are kept
  let dataIdParts = [];
  dataid.split('.').forEach(idPart => {
    if (!isNaN(idPart)) {
      return;
    }
    if (idPart.includes('[')) {
      Array.prototype.push.apply(dataIdParts, idPart.replace(/]/g, '').split('['));
    } else {
      dataIdParts.push(idPart);
    }
  });

  // Use path's ending * as it's easier and a shorter list to have all direct properties for any included object
  // Add this path and all paths that lead to it (until path is already included)
  let dataPath;
  while (dataIdParts.length > 0) {
    dataIdParts[dataIdParts.length - 1] = '*';
    dataPath = dataIdParts.join('.');
    if (messageDefinition[dataPath]) {
      break;
    }
    messageDefinition[dataPath] = true;
    dataIdParts.pop();
  }
}
